import {
  AppHeader,
  Box,
  Button,
  Container,
  Form,
  Radio,
  RadioGroup,
  RadioTypography,
  Stack,
  Typography,
  useRadioGroupValidator,
} from '@ace-clublabs/shared-component-library';
import { setGlobalState, useGlobalState } from '../state/state';
import { useEffect, useLayoutEffect, useState } from 'react';
import { AUTH_STORAGE_LABEL, Pages } from '../utils/constants';
import { useHistory } from 'react-router-dom';
import { UtagHelper, UtagType } from '../utils/UtagHelper';
import { Cookies } from 'react-cookie';
import { jwtDecode } from 'jwt-decode';

export const SelectMember: React.FC = () => {
  const history = useHistory();
  const [memberDetails] = useGlobalState('memberDetails');
  const [tags] = useGlobalState('tags');
  const [isTagging, setTagging] = useState(true);
  const [selectedCustomerId, setSelectedCustomerId] = useState(memberDetails.selectedCustomerId);
  const cookies = new Cookies();
  const jwtCustId = (jwtDecode(cookies.get(AUTH_STORAGE_LABEL)) as any)?.customerId;
  const hasActiveSession = () => jwtCustId === memberDetails.loggedInCustomerId;

  const radioValidator = useRadioGroupValidator();

  useEffect(() => {
    if (!hasActiveSession()) {
      history.push(Pages.HomePage);
    } else {
      window.history.replaceState(null, '', window.location.href);
    }
  }, []);

  useLayoutEffect(() => {
    UtagHelper.sendTag(UtagType.view, tags, 'select member', {});
    setTagging(false);
  }, []);

  if (isTagging) {
    return <></>;
  }

  let { members } = memberDetails;

  const membersItems =
    members?.map((member, i) => {
      const { firstName, middleName, lastName, nameSuffix, roleType, spinOffStatus } = member;
      const formattedMiddleInitial = middleName ? `${middleName.charAt(0).toUpperCase()} ` : '';
      const suffix = nameSuffix ? `, ${nameSuffix.toUpperCase()}` : '';
      const memberName = `${firstName} ${formattedMiddleInitial}${lastName}${suffix}`;
      return {
        memberName,
        memberRole: roleType,
        customerId: member.customerId,
      };
    }) || [];

  return (
    <>
      <Container maxWidth="sm">
        <Box>
          <AppHeader sx={{ padding: '0 !important' }} />
          <Stack marginTop="1rem">
            <Typography variant="h5Medium" className="select-member-title">
              Whose membership card do you want to download?
            </Typography>
            <Typography variant="b1Regular" className="select-member-description" marginTop="0.5rem">
              Membership cards can be printed or added to your smartphone for instant access.
            </Typography>
            <Form sx={{ marginTop: 0 }}>
              <Box marginTop="1rem" width={'100%'} className="select-member-radio-group">
                <RadioGroup
                  label="Select a member"
                  validator={radioValidator}
                  fullWidth
                  defaultValue={memberDetails.selectedCustomerId}
                >
                  {membersItems.map((member, i) => (
                    <Radio
                      name={member.memberName}
                      value={member.customerId}
                      id={`member-${i}`}
                      key={i}
                      label={<RadioTypography data-qm-block="true">{member.memberName}</RadioTypography>}
                      checked={member.customerId === selectedCustomerId}
                      onClick={(v) => {
                        setSelectedCustomerId(member.customerId);
                        setGlobalState('memberDetails', (prev) => ({ ...prev, selectedCustomerId: member.customerId }));
                      }}
                    />
                  ))}
                </RadioGroup>
              </Box>
              <Button
                className="select-member-next-button"
                label="Next"
                type="submit"
                onClick={() => {
                  history.push(Pages.MembershipCard);
                }}
                fullWidth
                sx={{ marginTop: '1.5rem' }}
              />
            </Form>
          </Stack>
        </Box>
      </Container>
    </>
  );
};
